module.exports = __webpack_public_path__ + "img/PNG_picture_icon@2x.aef8952e.png";